import React, {useContext} from "react";
import "./Skills.scss";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import {skillsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import LanguageContext from "../../contexts/LanguageContext";
import {translations} from "../../translations";

export default function Skills() {
  const {isDark} = useContext(StyleContext);
  const {isEnglish} = useContext(LanguageContext);
  const currentLang = isEnglish ? translations.en : translations.pt;

  if (!skillsSection.display) {
    return null;
  }
  return (
    <div className={isDark ? "dark-mode main" : "main"} id="skills">
      <div className="skills-main-div">
        <Fade right duration={1000}>
          <div className="skills-text-div">
            <h1
              className={isDark ? "dark-mode skills-heading" : "skills-heading"}
            >
              {currentLang.skills.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle skills-text-subtitle"
                  : "subTitle skills-text-subtitle"
              }
              style={{ textAlign: "justify" }}
            >
              {currentLang.skills.subtitle}
            </p>
            <SoftwareSkill />
            <p
              className={
                isDark
                  ? "dark-mode subTitle skills-also-working"
                  : "subTitle skills-also-working"
              }
            >
              {currentLang.skills.alsoWorking}
            </p>
            <div>
              {currentLang.skills.skills.map((skill, i) => {
                return (
                  <p
                    key={i}
                    className={
                      isDark
                        ? "dark-mode subTitle skills-text"
                        : "subTitle skills-text"
                    }
                  >
                    {skill}
                  </p>
                );
              })}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}
